// action errors may be in a variety of formats, distill them
export default (action) => {
  if (action.error) {
    if (action.error.response) {
      return action.error.response.statusText;
    }
  }
  return action.error;
};
